import { render, staticRenderFns } from "./AssignmentHistoryReportPopUp.vue?vue&type=template&id=0bba67cc&scoped=true"
import script from "./AssignmentHistoryReportPopUp.vue?vue&type=script&lang=js"
export * from "./AssignmentHistoryReportPopUp.vue?vue&type=script&lang=js"
import style0 from "./AssignmentHistoryReportPopUp.vue?vue&type=style&index=0&id=0bba67cc&prod&module=true&scoped=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "0bba67cc",
  null
  
)

export default component.exports